import { render } from "./RiArrowDown.vue?vue&type=template&id=ec6b7464"
import script from "./RiArrowDown.vue?vue&type=script&lang=js"
export * from "./RiArrowDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiArrowDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec6b7464"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec6b7464', __exports__)) {
    api.reload('ec6b7464', __exports__)
  }
  
  module.hot.accept("./RiArrowDown.vue?vue&type=template&id=ec6b7464", () => {
    api.rerender('ec6b7464', render)
  })

}


export default __exports__